import { forwardRef } from 'react';
import { Button } from 'tombac';
import { ForwardIcon } from 'tombac-icons';
import { jsx as _jsx } from "react/jsx-runtime";
function forwardButton(props, ref) {
  return /*#__PURE__*/_jsx(Button, {
    append: /*#__PURE__*/_jsx(ForwardIcon, {}),
    appendedHoverEffect: "anim-forward",
    ref: ref,
    theme: {
      color: '--primary'
    },
    variant: "flat",
    ...props,
    "data-sentry-element": "Button",
    "data-sentry-component": "forwardButton",
    "data-sentry-source-file": "CtaButton.tsx"
  });
}
forwardButton.displayName = 'CtaButton';
export const CtaButton = /*#__PURE__*/forwardRef(forwardButton);